import { getRequestDeletePreview } from '../../../shared/api/requests.api'
import { confirm } from '../../../shared/ui/confirmStore'

/**
 * Единый confirm удаления заявки с составом («позиций N, квот M, КП K»).
 * Используется кнопкой в списке (RequestsDeleteButton) и карточкой заявки
 * (useRequestActions), чтобы тексты не разъезжались.
 *
 * Превью тянется с бэка; если запрос упал — показываем confirm без состава
 * (удаление всё равно мягкое, заявка уходит в корзину на 30 дней).
 */
export async function confirmRequestDeletion(
  requestId: string,
  clientName?: string | null,
): Promise<boolean> {
  let composition = ''
  let retentionDays = 30
  try {
    const p = await getRequestDeletePreview(requestId)
    retentionDays = p.retentionDays
    composition = `Состав: позиций — ${p.itemsCount}, квот — ${p.quotesCount}, КП — ${p.kpCount}. `
  } catch {
    // превью не критично — confirm покажем и без него
  }
  return confirm({
    title: `Удалить заявку клиента «${clientName ?? '—'}»?`,
    message:
      `${composition}Заявка будет перемещена в корзину — восстановить можно в течение ` +
      `${retentionDays} дней (кнопка «Корзина» на странице заявок).`,
    danger: true,
    confirmText: 'Удалить',
  })
}
